import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type FullscreenButtonProps = {
  isFullscreen: boolean;
  containerRef: React.RefObject<HTMLDivElement | null>;
};

export function FullscreenButton({ isFullscreen, containerRef }: FullscreenButtonProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      aria-label={isFullscreen ? t('Exit fullscreen') : t('Fullscreen')}
      sx={{ color: theme => theme.palette.common.white }}
    >
      {isFullscreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
    </IconButton>
  );
}
